export const NotificationsListingGetters = {
  Notifications: 'Notifications',
  ProfileNotifications: 'ProfileNotifications',
  ProfileUnreadNotifications: 'ProfileUnreadNotifications',
  IsAnyNotificationChecked: 'IsAnyNotificationChecked',
  SelectedNotifications: 'SelectedNotifications',
  TotalUnreadNotifications: 'TotalUnreadNotifications',
  AreAllNotificationsSelected: 'AreAllNotificationsSelected'
};

export const NotificationsListingMutations = {
  RetrieveNotificationsSuccess: 'retrieveNotificationsSuccess',
  RetrieveProfileNotificationsSuccess: 'retrieveProfileNotificationsSuccess',
  UpdateSelectedNotifications: 'updateSelectedNotifications',
  ResetNotificationsState: 'resetNotificationsState'
};

export const NotificationsListingActions = {
  RetrieveNotifications: 'retrieveNotifications',
  RetrieveNotificationsByReferenceNumber: 'retrieveNotificationsByReferenceNumber',
  SelectNotification: 'selectNotification',
  SetInitialNotificationsState: 'setInitialNotificationsState',
  DeleteSelectedNotifications: 'deleteSelectedNotifications',
  SetNotificationStatus: 'setNotificationStatus'
};
